module.exports = __webpack_public_path__ + "img/sucess_follow.c2895e9.png";